// skeleton/app/src/app/landingpage/landingpagecomponent.ts

import { Component, OnInit } from "@angular/core";
import { UserServiceService } from "../user/survey-main/service/user-service.service";
import { GlobalsessionhandlerService } from "../shared/services/globalsessionhandler.service";
import { BaseHttpService } from "../shared/services/basehttp.service";
import { Constants } from "../shared/constants";
import { firstValueFrom } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import DOMPurify from "dompurify";
import { StorageService } from "../shared/services/token-storage.service";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landingpagecomponent.html",
  styleUrl: "./landingpagecomponent.scss",
  standalone: false,
})
export class LandingPageComponent implements OnInit {
  userName: string = "";
  constants: Constants = new Constants();
  surveyDueDate: Date;
  diffDate: number;
  bannerString: string = "";
  agencyName: string = "";
  formattedDate: string;
  bannerDetails: any;

  constructor(
    private userService: UserServiceService,
    private sessionHandlerService: GlobalsessionhandlerService,
    private baseHttpService: BaseHttpService,
    private sanitizer: DomSanitizer,
    private storage: StorageService
  ) {}

  async ngOnInit() {
    this.userName = this.storage.get("LoggedInuserFirstName");
    const agency = this.storage.get("LoggedInUserAgency");
    this.agencyName = agency ? this.capitalizeWords(agency.toLowerCase()) : "";

    if (this.userName == null || this.agencyName == null) {
      this.GetUser();
    }

    await this.GetSurveyDueDate();
    this.GetSurveyBannerDetails();

    if (this.surveyDueDate == null) {
      this.surveyDueDate = new Date("9999-12-31T23:59:59");
    }

    this.formattedDate = this.surveyDueDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
  }

  GetUser() {
    this.baseHttpService.get(this.constants.getUser).subscribe((result) => {
      if (result != null) {
        this.userService.getUserDeatils(result);

        const loginname = (result.fullName || "").split(",");
        this.userName = (loginname[1] || "").trim();
        this.agencyName = result.userAgency;

        this.storage.set("LoggedInuserId", JSON.stringify(result.customerId));
        this.storage.set("LoggedInuserMailId", result.email);
        this.storage.set("LoggedInUserTypeId", result.userTypeId);
        this.storage.set("LoggedInUserTypeDesc", result.userTypeDesc);
        this.storage.set("LoggedInUserAgency", result.userAgency);

        // Keep existing session handler usage
        this.sessionHandlerService.setLoggedInUserName(
          `${(loginname[1] || "").trim()}, ${(loginname[0] || "").trim()}`
        );
        this.sessionHandlerService.setUserGroupId(result.userGroupId);
        this.storage.set("UserGroupId", result.userGroupId);
      }
    });
  }

  async GetSurveyDueDate() {
    const userGrp = this.storage.get("UserGroupId");
    if (userGrp != null) {
      try {
        const result = await firstValueFrom(
          this.baseHttpService.getById(this.constants.getSurveyDueDateByUserGrp, userGrp)
        );
        this.surveyDueDate = new Date(result) ?? new Date("9999-12-31T23:59:59");
      } catch (error) {
        this.surveyDueDate = new Date("9999-12-31T23:59:59");
      }
    }
  }

  GetSurveyBannerDetails() {
    const userType = this.storage.get("LoggedInUserTypeDesc");
    const userGroupId = this.storage.get("UserGroupId");
    const url = this.constants.getSurveyBannerDetails + "/" + userType + "/" + userGroupId;

    if (userType != null && userGroupId != null) {
      this.baseHttpService.get(url).subscribe((data: any[]) => {
        data.sort((a, b) => a.sequence - b.sequence);
        data.forEach((x) => {
          const cleanHtml = DOMPurify.sanitize(x.htmlText);
          x.htmlText = this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
        });
        this.bannerDetails = data;
      });
    }

    return null;
  }

  capitalizeWords(str: string) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
